import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";
import {ChangeTypeEnum} from "./GatewayPendingConfigPayloadDTO";
import {SendingCronFrequencyEnum} from "../../enums/registry/SendingCronFrequencyEnum";

class GatewayTypeAdditionalInfoDTO {
  rtuPorts?: string[];
}

class GatewayTypeDTO {
  id!: number;
  modelName!: string;
  partNumber?: string;
  osType!: string;
  additionalInfo!: GatewayTypeAdditionalInfoDTO;
}

// Same shape as the BE GetGatewayCB.O.GatewayDTO: name, type and sendingCron come from the
// pending-config draft when it proposes a gateway block (O.status === UPDATED),
// every other field is always read from the official reg_gateway row.
class GatewayDTO {
  id!: number;
  name!: string;
  partitionId!: number;
  type!: GatewayTypeDTO;
  macAddress?: string;
  online!: boolean;
  status!: string;
  updateWorkflowStatusTs!: string;
  sendingCron?: SendingCronFrequencyEnum;
  netConfig?: string;

  // Always empty (hence never[], so it stays assignable to any device list type):
  // GetGatewayPayloadOpe does not populate the devices, unlike getGateway. Use
  // readGatewayPendingConfigFallback/getDevicePendingConfig for them.
  devices!: never[];

  hasPendingDevice!: boolean;
  hasPendingGatewayFields!: boolean;
}

/**
 * O Inner Class
 */
class O {
  gateway!: GatewayDTO;

  // UPDATED if the returned gateway fields come from the draft, CREATED if they were
  // rebuilt from the official row (never DELETED for the gateway itself).
  status!: ChangeTypeEnum;
}

/**
 * I Inner Class
 */
class I {
  gatewayId!: number;
}

export class GetGatewayPayloadCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayPendingConfigOPEEnum.GetGatewayPayload);
    this.i = new I();
    this.o = new O();
  }
}
